export default class LocationNearYou extends HTMLElement {
  constructor() {
    super();
    this.locations = [];
    this.blockedLocations = [
      "greensboro",
      "huntsville",
      "westminster",
      "fort worth",
      "winnipeg",
      "spanish fort",
      "minneapolis",
      "atlanta",
      "dallas",
      "charlotte"
    ];
    this.activeCountry = null;
  }

  connectedCallback() {
    fetch("/wp-json/badaxe/v1/location/list")
      .then((response) => response.json())
      .then((data) => {
        this.locations = data;
        this.render();
      });

    // Close dropdown when clicking outside
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target) && !document.querySelector('.locations-dropdown')?.contains(event.target)) {
        this.closeDropdown();
      }
    });
  }

  render() {
    this.innerHTML = "";
    const container = document.createElement("div");
    container.classList.add("w-full");

    container.innerHTML = `
    <div class="location-near-you w-full">
      <div class="container mx-auto w-full px-4">
        <div class="flex flex-col sm:flex-row flex-wrap justify-center items-center my-2 md:my-4 w-full gap-2 sm:gap-3">
          <div class="relative inline-block w-full sm:w-auto mb-1 sm:mb-0">
            <button data-country="canada" class="btn-country btn-canada bg-black text-white rounded-md py-3 px-6 flex items-center justify-between space-x-2 border-2 border-gray-400 hover:border-white transition ease-in-out w-full sm:w-72 mr-0 sm:mr-2">
              <div class="flex items-center">
                <img src="/wp-content/themes/badaxe/img/flags/canada.svg" alt="Canada Flag" class="w-6 h-6 rounded-full mr-2">
                <span class="text-base sm:text-lg">CA</span>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
            <div class="dropdown-container canada-dropdown hidden absolute z-50 mt-1 w-full"></div>
          </div>
          
          <div class="relative inline-block w-full sm:w-auto">
            <button data-country="us" class="btn-country btn-us bg-black text-white rounded-md py-3 px-6 flex items-center justify-between space-x-2 border-2 border-gray-400 hover:border-white transition ease-in-out w-full sm:w-72 ml-0 sm:ml-2">
              <div class="flex items-center">
                <img src="/wp-content/themes/badaxe/img/flags/us.svg" alt="US Flag" class="w-6 h-6 rounded-full mr-2">
                <span class="text-base sm:text-lg">U.S.</span>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
            <div class="dropdown-container us-dropdown hidden absolute z-50 mt-1 w-full"></div>
          </div>
        </div>
      </div>
    </div>
    `;

    this.appendChild(container);

    // Add event listeners for country buttons
    this.querySelectorAll(".btn-country").forEach((btn) => {
      btn.addEventListener("click", this.handleCountryClick.bind(this));
    });
  }

  closeDropdown() {
    // Hide all dropdowns
    this.querySelectorAll('.dropdown-container').forEach(dropdown => {
      dropdown.classList.add('hidden');
      dropdown.innerHTML = '';
    });

    // Remove active class from all buttons
    this.querySelectorAll('.btn-country').forEach(button => {
      button.classList.remove('active');
      button.classList.remove('border-white');
    });

    this.activeCountry = null;
  }

  handleCountryClick(event) {
    const country = event.currentTarget.dataset.country;
    const dropdownContainer = this.querySelector(`.${country}-dropdown`);

    // If clicking the same country button that's already active, close the dropdown
    if (this.activeCountry === country) {
      this.closeDropdown();
      return;
    }

    // Close any open dropdown
    this.closeDropdown();

    // Set this country as active
    this.activeCountry = country;

    // Add active class to clicked button
    event.currentTarget.classList.add('active');
    event.currentTarget.classList.add('border-white');

    // Get locations for selected country
    const locationsHtml = this.getLocationsForCountry(country);

    // Update and show the dropdown
    if (dropdownContainer) {
      dropdownContainer.innerHTML = locationsHtml;
      dropdownContainer.classList.remove('hidden');
    }
  }

  getLocationsForCountry(country) {
    // Filter locations by country
    const filteredLocations = this.locations.filter(location => {
      return !this.blockedLocations.includes(location.name.toLowerCase()) &&
        location.country.toLowerCase() === country.toLowerCase();
    });

    // Sort locations by name
    filteredLocations.sort((a, b) => a.name.localeCompare(b.name));

    if (filteredLocations.length === 0) {
      return '<p class="text-center py-4 text-white">No locations available in this country.</p>';
    }

    // Create the locations dropdown
    let html = `
    <div class="w-full mx-auto">
      <div class="bg-black rounded-lg overflow-hidden border-2 border-gray-800 shadow-lg">
        <ul class="text-white divide-y divide-gray-800 max-h-[300px] overflow-y-auto">
    `;

    // Add locations to the dropdown
    filteredLocations.forEach(location => {
      html += `
        <li>
          <a href="${location.url}" target="_blank" class="block py-3 px-4 hover:bg-gray-800 transition-colors text-center text-sm sm:text-base">
            ${location.name}
          </a>
        </li>
      `;
    });

    html += `
        </ul>
      </div>
    </div>
    `;

    return html;
  }

  disconnectedCallback() { }
}
